import { memo } from 'react';
import { GalleryCard } from '../GalleryCard';
import type { GalleryProfileCard } from '../../../types/gallery';
import './ListLayout.css';

// ==========================================
// TYPES
// ==========================================

interface ListLayoutProps {
  profiles: GalleryProfileCard[];
  onProfileClick: (profileId: string, position: number) => void;
  onSwipeStart: (profileId: string) => void;
  selectedProfileId?: string;
  showDividers?: boolean;
  className?: string;
}

// ==========================================
// COMPONENT
// ==========================================

function ListLayoutComponent({
  profiles,
  onProfileClick,
  onSwipeStart,
  selectedProfileId,
  showDividers = false,
  className = '',
}: ListLayoutProps) {
  if (profiles.length === 0) {
    return null;
  }

  const listClass = ['gallery-list', showDividers ? 'gallery-list--dividers' : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={listClass}>
      {profiles.map((profile, index) => (
        <div key={profile.profileId} className="gallery-list__item">
          <GalleryCard
            profile={profile}
            variant="full"
            onClick={() => onProfileClick(profile.profileId, index)}
            onSwipeStart={() => onSwipeStart(profile.profileId)}
            isSelected={profile.profileId === selectedProfileId}
          />
        </div>
      ))}
    </div>
  );
}

export const ListLayout = memo(ListLayoutComponent);
